import { createSlotRecipe } from './runtime';

const qrCodeConfig = {"name":"qrCode","slots":["root","frame","pattern","overlay"]}

export const qrCode = /* @__PURE__ */ createSlotRecipe(qrCodeConfig)